<template>
    <div class="project_home">
        <div class="project_content">
            <h2 class="project-title">苏州高新区2026年第二次面向社会认定中小学教师资格  现场确认预约</h2>
            <div style="padding:0 10px">
                <!-- <el-alert title="友情提示：对于今年已经参加苏州大市范围内教育行政部门组织的新教师入职体检的人员，在本次认定时可用当地教育行政部门开具的《体检合格证明》替代体检报告。" type="warning"
                    :closable="false">
                </el-alert> -->
                <!-- <div style="text-align:center;margin-top:20px;">
                    <el-button type="primary" style="width:300px" round @click="physicalPreengage">体检预约</el-button>
                </div> -->
                <div style="text-align:center;margin-top:20px;margin-bottom:20px;">
                     <el-button type="danger" style="width:300px" round @click="confirmPreengage">现场确认预约</el-button>
                     </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    mounted() {
        switch (this.$global.status) {
            case -1:
                this.$router.push('/schoolHome/login')
                break;
            case 1:
                this.$router.push('/schoolHome/projectRecord')
                break;
            case 2:
                this.$router.push('/schoolHome/confirmRecord')
                break;
        }
    },
    methods: {
        physicalPreengage() {
            this.$router.push('/schoolHome/projectList')
        },
        confirmPreengage() {
            this.$router.push('/schoolHome/confirmList')
        }
    }
}
</script>
<style scoped>
.project_home {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 70px;
    padding-bottom: 10px;
    background-color: #f1f1f1;
    background-image: linear-gradient(to top, #6a85b6 0%, #bac8e0 100%);
    overflow-y: auto;
}

.project-title {
    text-align: center;
    padding: 10px;
    color: #454545;
}

.project_content {
    width: 800px;
    margin: 0 auto;
}

.project_item {
    margin-top: 10px;
    background-image: linear-gradient(to top, #a8edea 0%, #fed6e3 100%);
    border-radius: 5px;
    line-height: 40px;
    padding: 10px;
}

.project_date {
    font-size: 18px;
    font-weight: bold;
    color: #12731e;
}

.project_number {
    font-size: 18px;
    color: #1f0d3c;
    margin-left: 10px;
}

@media (max-width:768px) {
    .project_content {
        width: 100%;
    }
}
</style>